import { useQuery } from "@tanstack/react-query";
import { useCallback, useState } from "react";
import { getMerchantWinners } from "services/apiwinners";

export function useMerchantWinners(size = 20, filters = {}) {
  const [currentPage, setCurrentPage] = useState(0);

  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["merchantWinners", currentPage, size, filters],
    queryFn: () => getMerchantWinners(currentPage, size, filters),
    keepPreviousData: true,
    enabled: filters.gameSlotId != null,
  });

  const winners = Array.isArray(data?.content) ? data.content : [];
  const totalPages = Math.max(data?.totalPages ?? 0, 1);
  const totalElements = data?.totalElements ?? winners.length ?? 0;
  const hasNextPage = currentPage < totalPages - 1;
  const hasPreviousPage = currentPage > 0;

  const goToNextPage = () => {
    if (hasNextPage) setCurrentPage((prev) => prev + 1);
  };

  const goToPreviousPage = () => {
    if (hasPreviousPage) setCurrentPage((prev) => prev - 1);
  };

  const resetPage = useCallback(() => setCurrentPage(0), []);

  return {
    winners,
    error,
    isLoading,
    isFetching,
    refetch,
    hasNextPage,
    hasPreviousPage,
    totalPages,
    totalElements,
    goToNextPage,
    goToPreviousPage,
    currentPage,
    resetPage,
  };
}
